import { registerSW } from 'virtual:pwa-register'

const IDLE_TIMEOUT = 10_000 // 10 seconds

let updatePending = false
let idleTimer: ReturnType<typeof setTimeout> | null = null
let updateSW: ((reloadPage?: boolean) => Promise<void>) | null = null

/** Check if a service worker update is waiting to be applied */
export function isUpdatePending(): boolean {
  return updatePending
}

/** Activate the waiting service worker and reload the page */
export function applyUpdate(): void {
  if (updatePending) {
    updateSW?.(true)
  }
}

// ── Idle fallback ──────────────────────────────────────────────
// If the user stops interacting for 10s and an update is pending, reload.
function resetIdleTimer() {
  if (idleTimer) clearTimeout(idleTimer)
  if (!updatePending) return

  idleTimer = setTimeout(() => {
    updateSW?.(true)
  }, IDLE_TIMEOUT)
}

function startIdleWatcher() {
  const events = ['mousemove', 'keydown', 'touchstart', 'scroll', 'click']
  for (const event of events) {
    window.addEventListener(event, resetIdleTimer, { passive: true })
  }
  resetIdleTimer()
}

// ── Register the service worker ────────────────────────────────
updateSW = registerSW({
  onNeedRefresh() {
    updatePending = true
    startIdleWatcher()
  },
  onOfflineReady() {
    // App is cached and ready for offline use
  },
})

// ── Poll for new service worker every 60s ──────────────────────
async function checkForSwUpdate() {
  if (!('serviceWorker' in navigator)) return
  try {
    const registration = await navigator.serviceWorker.getRegistration()
    await registration?.update()
  } catch (_) {
    // Network error or SW not registered — ignore
  }
}

setInterval(checkForSwUpdate, 60_000)

// Also check when the user switches back to this tab
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    checkForSwUpdate()
  }
})
